<template>
    <v-dialog
        v-model    = "show"
        transition = "dialog-bottom-transition"
        fullscreen
        hide-overlay
        persistent
        no-click-animation
        v-resize="onResize"
    >
        <div class="white" style="margin-top: 6px;height: calc(100% - 15px); width: calc(100% - 75px); ">
            <f-dialog-title
                title   = "OUTBOX"
                @cancel = "onClose"
                style="border-radius: 4px;margin-left: 75px; "
            >
            </f-dialog-title>

            <div class="w-100 mt-1" style="margin-left: 75px;">
                <p-inc-outbox
                    :height = "height"
                    @close  = "onClose"
                />
            </div>
        </div>
    </v-dialog>
</template>

<script>

import FDialogTitle from "@/modules/core/components/utils/FDialogTitle";
import PIncOutbox from "@/modules/inc/outbox/components/private/PIncOutbox.vue";

export default {
    name: "DIncOutbox",

    components: {
        PIncOutbox,
        FDialogTitle,
    },

    props: {
        value: {},
    },

    data: () => ({
        show: false,
        height: null,
    }),

    mounted() {
        this.show = this.value;
        this.onResize();
    },

    watch: {
        value() {
            this.show = this.value;
        },
    },

    methods: {
        onClose () {
            this.$emit("input", false);
        },

        onResize() {
            this.height = window.innerHeight - 240;
        },
    }
}

</script>

<style scoped>

</style>